import { expect, is, test } from "@benchristel/taste"
import { render } from "preact"
import { useLayoutEffect } from "preact/hooks"
import { uiTest } from "./testUtilities"

export function PageTitle({
  value,
  _window = window,
}: {
  value: string
  _window?: Window
}): null {
  useLayoutEffect(() => {
    _window.document.title = value
  }, [value])
  return null
}

test("PageTitle", {
  "sets the page title on mount": uiTest((el) => {
    const fakeWindow: any = { document: { title: "" } }
    render(<PageTitle value="Sardines" _window={fakeWindow} />, el)
    expect(fakeWindow.document.title, is, "Sardines")
  }),

  "updates the page title when the value prop changes": uiTest((el) => {
    const fakeWindow: any = { document: { title: "" } }
    render(<PageTitle value="One" _window={fakeWindow} />, el)
    render(<PageTitle value="Two" _window={fakeWindow} />, el)
    expect(fakeWindow.document.title, is, "Two")
  }),
})
